var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{directives:[{name:"resize",rawName:"v-resize"}],attrs:{"id":"investment-catalog-iframe","src":_vm.iframeSrc,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }